import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {useTranslate} from "../useTranslate";
import Icon from "./icon";

const FILTER_PT = {
    input: {className: "text-xs flex align-items-center"},
    item: {className: "text-xs p-2"},
    wrapper: {className: "scrollbar-hide"},
    emptyMessage: {className: "text-xs p-3"},
    filterInput: {className: "text-xs z-rtl-dropdown-filter-input"},
    filterIcon: {className: "z-rtl-dropdown-filter-icon"},
    header: {className: "p-2 z-rtl-dropdown-filter-header"},
};

function mergePt(base, custom = {}) {
    return Object.fromEntries(
        [...new Set([...Object.keys(base), ...Object.keys(custom)])].map((key) => {
            const baseValue = base[key];
            const customValue = custom[key];
            if (!baseValue) return [key, customValue];
            if (!customValue) return [key, baseValue];
            if (typeof baseValue === "object" && typeof customValue === "object") {
                return [key, {
                    ...baseValue,
                    ...customValue,
                    className: [baseValue.className, customValue.className].filter(Boolean).join(" "),
                }];
            }
            return [key, customValue];
        }),
    );
}

export default function ClearableDropdown({
    value,
    onChange,
    onClear,
    className = "",
    panelClassName = "",
    pt,
    clearAriaLabel,
    disabled = false,
    ...props
}) {
    const translate = useTranslate();
    const clear = () => {
        if (onClear) {
            onClear();
            return;
        }
        onChange?.({value: null, originalEvent: null});
    };

    return (
        <div className="z-clearable-dropdown flex align-items-center gap-1 w-full">
            <Dropdown
                {...props}
                value={value}
                onChange={onChange}
                disabled={disabled}
                showClear={false}
                className={`flex-1 min-w-0 ${className}`.trim()}
                panelClassName={`text-xs ${panelClassName}`.trim()}
                pt={mergePt(FILTER_PT, pt)}
            />
            <Button
                type="button"
                text
                severity="danger"
                className="p-1 flex-none"
                icon={<Icon icon="pi pi-times" className="text-sm"/>}
                aria-label={clearAriaLabel || translate("delete")}
                disabled={disabled || value === null || value === undefined}
                onClick={clear}
            />
        </div>
    );
}
